import { useState } from 'react';
import axios from 'axios';
import { readPosition } from '../geolocationCapture';
import { apiError } from '../shared';

export const useGeoControlCapture = (base, onRefresh) => {
  const [queue, setQueue] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const prepare = (entry, phase) => {
    const event = [...(entry.geo_control?.events || [])].reverse().find(e => e.phase === phase && e.declared_at === (phase === 'start' ? entry.started_at : entry.ended_at));
    if (!event) return false;
    setQueue(items => [...items, { entry, event }]);
    return true;
  };
  const answer = async capture => {
    const target = queue[0];
    if (!target || busy) return;
    setBusy(true); setError('');
    try {
      const payload = capture ? (await readPosition()).payload : { status: 'indisponible', detail: 'Impossibilité signalée avant relevé' };
      await axios.post(`${base}/geo-control/${target.entry.entry_id}/${target.event.event_id}/location`, payload, { withCredentials: true, timeout: 15000 });
    } catch (e) { setError(`${apiError(e)}. L’horaire reste enregistré. Actualisez le contrôle du lieu ; tout résultat non reçu laisse une exception à examiner.`); }
    finally { setQueue(items => items.slice(1)); setBusy(false); onRefresh(); }
  };
  return { prepare, pending: queue[0], busy, error, accept: () => answer(true), problem: () => answer(false) };
};